var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "upload-file"
  }, [_c('b-modal', {
    attrs: {
      "id": "memberCardPaymentsModal",
      "centered": "",
      "size": "xl",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "v-model": _vm.showCardPaymentsModal
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "member-card-payments-header text-center"
        }, [_c('h4', [_vm._v("Card Request Payments")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "member-card-payments-form"
  }, [_c('div', {
    staticClass: "member-card-payments-form"
  }, [_c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "info-detail"
  }, [_vm._v("Payment Details")]), _c('div', {
    staticClass: "page-card p-0 table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("S.N")]), _c('th', [_vm._v("Card Id")]), _c('th', [_vm._v("Payer Id")]), _c('th', [_vm._v("Amount")]), _c('th', [_vm._v("Payment ID")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Description")]), _c('th', [_vm._v("Clearing Date")]), _c('th', [_vm._v("Invoice ID")]), _c('th', [_vm._v("Card Status")]), _c('th', [_vm._v("Cards Requested")])])]), _c('tbody', [_vm.repInfoPaymentDetails && _vm.repInfoPaymentDetails.length > 0 ? _vm._l(_vm.repInfoPaymentDetails, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(++index))]), _c('td', [_vm._v(_vm._s(item.card_id))]), _c('td', [_vm._v(_vm._s(item.payer_id))]), _c('td', [_vm._v("$" + _vm._s(item.amount))]), _c('td', [_vm._v(_vm._s(item.payment_id))]), _c('td', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(item.status))]), _c('td', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(item.payment_description))]), _c('td', [_vm._v(_vm._s(item.clearing_date))]), _c('td', [_vm._v(_vm._s(item.invoice_id))]), _c('td', {
      staticClass: "text-capitalize"
    }, [_vm._v(" " + _vm._s(item.card_status ? item.card_status.toLowerCase().replace(/[_ ]/g, '-') : '') + " ")]), _c('td', [_vm._v(_vm._s(item.cards_requested))])]);
  }) : [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("No records found.")])])]], 2)])])])])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }